<div class="consultation-banner" [class.banner-unlocked]="consultationStatus === StepStatus.COMPLETED">
  <div class="banner-content">
    <div class="banner-text">

      <!-- AVAILABLE: default state -->
      <ng-container *ngIf="consultationStatus === StepStatus.AVAILABLE">
        <span class="step-label-chip">{{ 'pricing.step2.label' | translate }}</span>
        <h3 class="banner-title">{{ 'consultationBanner.title' | translate }}</h3>
        <p class="banner-desc">{{ 'consultationBanner.desc' | translate }}</p>
        <div class="banner-features">
          <span *ngFor="let feature of features" class="feature-chip">
            <mat-icon class="check-icon">check_circle</mat-icon>
            {{ feature | translate }}
          </span>
        </div>
      </ng-container>

      <!-- PENDING_VALIDATION: booked, awaiting admin confirmation -->
      <ng-container *ngIf="consultationStatus === StepStatus.PENDING_VALIDATION">
        <span class="step-label-chip">{{ 'pricing.step2.label' | translate }}</span>
        <h3 class="banner-title">{{ 'consultationBanner.pendingTitle' | translate }}</h3>
        <p class="banner-desc">{{ 'consultationBanner.pendingDesc' | translate }}</p>
        <div *ngIf="consultationStep?.bookingDate" class="booking-info">
          <span class="booking-chip">
            <mat-icon class="chip-icon">calendar_today</mat-icon>
            {{ formatBookingDate() }}
          </span>
          <span class="booking-chip">
            <mat-icon class="chip-icon">schedule</mat-icon>
            {{ formatBookingTime() }}
          </span>
        </div>
      </ng-container>

      <!-- IN_PROGRESS: admin confirmed the consultation -->
      <ng-container *ngIf="consultationStatus === StepStatus.IN_PROGRESS">
        <span class="step-label-chip">{{ 'pricing.step2.label' | translate }}</span>
        <h3 class="banner-title">{{ 'consultationBanner.confirmedTitle' | translate }}</h3>
        <p class="banner-desc">{{ 'consultationBanner.confirmedDesc' | translate }}</p>
        <div *ngIf="consultationStep?.bookingDate" class="booking-info">
          <span class="booking-chip">
            <mat-icon class="chip-icon">calendar_today</mat-icon>
            {{ formatBookingDate() }}
          </span>
          <span class="booking-chip">
            <mat-icon class="chip-icon">schedule</mat-icon>
            {{ formatBookingTime() }}
          </span>
        </div>
      </ng-container>

      <!-- COMPLETED: show Step 3 card -->
      <ng-container *ngIf="consultationStatus === StepStatus.COMPLETED">
        <span class="step-label-chip step-label-chip--unlocked">{{ 'pricing.step3.label' | translate }}</span>
        <h3 class="banner-title">{{ 'pricing.step3.title' | translate }}</h3>
        <p class="banner-desc">{{ 'pricing.step3.desc' | translate }}</p>
      </ng-container>

    </div>

    <img
      src="assets/images/consultation-mascot.png"
      alt=""
      class="banner-mascot"
    />

    <div class="banner-cta">

      <!-- AVAILABLE: price + book button -->
      <ng-container *ngIf="consultationStatus === StepStatus.AVAILABLE">
        <div class="cta-price-block">
          <span class="cta-price">{{ formattedConsultationPrice }}</span>
          <span class="cta-note">{{ 'consultationBanner.note' | translate }}</span>
        </div>
        <button class="cta-btn" (click)="openModal()">
          <mat-icon>calendar_today</mat-icon>
          {{ 'pricing.step2.action' | translate }}
        </button>
      </ng-container>

      <!-- PENDING_VALIDATION: pending badge -->
      <div class="status-badge status-pending" *ngIf="consultationStatus === StepStatus.PENDING_VALIDATION">
        <mat-icon>event</mat-icon>
        {{ 'pricing.statusPendingValidation' | translate }}
      </div>

      <!-- IN_PROGRESS: confirmed badge -->
      <div class="status-badge status-confirmed" *ngIf="consultationStatus === StepStatus.IN_PROGRESS">
        <mat-icon>check_circle</mat-icon>
        {{ 'consultationBanner.statusConfirmed' | translate }}
      </div>

      <!-- COMPLETED: price + unlocked badge -->
      <ng-container *ngIf="consultationStatus === StepStatus.COMPLETED">
        <div class="cta-price-block">
          <span class="cta-price">{{ formatEmployerMatchPrice() }}</span>
          <span class="cta-note">{{ 'pricing.step3.note' | translate }}</span>
        </div>
        <div class="status-badge status-unlocked">
          <mat-icon>lock_open</mat-icon>
          {{ 'pricing.statusUnlocked' | translate }}
        </div>
      </ng-container>

    </div>
  </div>
</div>